module.exports = __webpack_public_path__ + "static/media/jiamin_xu.49b88cf3.png";